import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IntegrationImportParams } from '../../integration-imports.interface';
import { IntegrationsImportService } from '../../integration.import.service';
import { getIntegrationImportsParamsSelector } from '../../integration-imports.reducer';
import { GetIntegrationImportsAction } from '../../integration-imports.actions';
import { IState } from '../../../../shared/models/state';

@Component({
  selector: 'cc-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent implements OnInit {
  public filters: IntegrationImportParams;

  constructor(private integrationsImportService: IntegrationsImportService, private store: Store<IState>) {}

  ngOnInit() {
    this.store.select(getIntegrationImportsParamsSelector).subscribe(params => {
      this.filters = params;
    });
  }

  addFilter(phrase) {
    this.store.dispatch(
      new GetIntegrationImportsAction({
        search: phrase,
        pager: this.integrationsImportService.getPagerIndexReset(this.filters.pager)
      })
    );
  }
}
